import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateMapCenter } from '../../../../../reducers/_Pages/Public/radarSlice';

const RadarSelector = () => {
  const { addressObj, radius } = useSelector((state) => state.radar);
  const dispatch = useDispatch();

  const radiusOptions = [
    { label: '250m', value: 250 },
    { label: '500m', value: 500 },
    { label: '1km', value: 1000 },
  ];

  const selectorClasses = (val) => {
    return `flex items-center justify-center rounded-2xl p-3 w-full font-semibold bg-opacity-30 backdrop-blur-sm cursor-pointer ${val == radius ? 'border-2 bg-ih-blue/10 border-ih-blue' : 'border text-white bg-white/10 border-ih-white hover:bg-white/20'}`
  }
  
  return (
    <div className={`flex flex-col gap-3 overflow-hidden transition-all ${addressObj.lat ? 'h-24' : 'h-0'}`}>
      <p className='text-center md:text-left font-bold'>Définissez un rayon de recherche</p>

      <div className='flex items-center justify-center gap-3'>
        {radiusOptions.map((option) => (
          <div
            key={option.value}
            className={selectorClasses(option.value)}
            onClick={() => dispatch(updateMapCenter({ radius: option.value }))}
          >
            <p>{option.label}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default RadarSelector;
